export default "__VITE_ASSET__DadicPge__"